import { Page } from '../../../../../../components/page/page';
import { useLang } from '../../../../../../hooks/use-lang';
import { MenuInformerAiPrompt } from './menu-informer-ai-prompt/menu-informer-ai-prompt';
import { MenuInformerFileUpload } from './menu-informer-file-upload/menu-informer-file-upload';
import s from './menu-informer-import.module.css';
import { MenuInformerUploadedDishTable } from './menu-informer-uploaded-dish-table/menu-informer-uploaded-dish-table';

export const MenuInformerImport = () => {
  const { t } = useLang();

  return (
    <Page className={s.page}>
      <h2>{t('Импорт из файла')}</h2>

      <div className={s.content}>
        <MenuInformerFileUpload />
        <MenuInformerAiPrompt />
      </div>

      <MenuInformerUploadedDishTable />
    </Page>
  );
};
